<template>
    <div class="table table--hero table--files">
        <b-table @row-clicked="openEditorPopUp"
                 :class="{'has-selected-rows':massAction.length>0}"
                 :fields="fields"
                 :perPage="perPage"
                 :filter="search"
                 :items="items"
                 primary-key="id"
                 :sort-desc.sync="sortDesc"
                 :sort-by.sync="sortBy"
                 :sort-compare="sortCompare"
                 :tbody-tr-class="rowClass"
                 sort-icon-left>

            <template v-slot:head(check)="data">
                <b-form-checkbox :checked="isAllSelect" @change="selectAllCheckbox"></b-form-checkbox>
            </template>
            <template v-slot:cell(check)="data">
                <!--<b-form-checkbox-group v-model="massAction">-->
                    <!--<b-form-checkbox  @change="(e)=>{onChange({id:data.item.id, status:e})}" v-if="data.item.active" :value="data.item.id"></b-form-checkbox>-->
                <!--</b-form-checkbox-group>-->
            </template>

            <template v-slot:cell(name)="data">
            <span :class="[
            { 'text--500' : data.item.status_id == '5' },
            { 'text--muted' : data.item.status_id != '5' },
            { 'text--striked' : !data.item.active}
            ]" :title="data.item.filename">


                {{ fileNameCut(data.item.filename) }}
            </span>

                <span v-if="data.item.active && !data.item.upload">
                  <file-type-icon :file="data.item"></file-type-icon>
                  <!--<span class="text&#45;&#45;muted" v-if="data.item.printer_type !== 'No Printer'">{{data.item.printer_type}}</span>-->
               </span>
            </template>
            <template v-slot:cell(printing_duration)="data">
                <print-time v-if="data.item.printing_duration !== null" :estimated-time="data.item.printing_duration" :object-id="data.item.id"></print-time>
            </template>
            <template v-slot:cell(img)="data">
                <model-preview v-if="!data.item.upload" :file-id="data.item.id" :status-file="data.item.status_id" :icon-img="data.item.picture_preview" :preview-img="data.item.picture"></model-preview>
                <b-spinner v-else  variant="primary"  label="Spinning">
                    <slot>{{data.item.uploadProgress}}</slot>
                </b-spinner>
            </template>
            <template v-slot:cell(log)="data">
                <!--            <i class="icon icon&#45;&#45;file"-->
                <!--               :class="'icon&#45;&#45;file&#45;&#45;c-' + getFileTypeInfo(data.item.file_type_id).color "-->
                <!--            > <span>{{getFileTypeInfo(data.item.file_type_id).name}}</span>-->
                <!--                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" fill-rule="evenodd"-->
                <!--                     clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2">-->
                <!--                    <g>-->
                <!--                        <path class="file-body"-->
                <!--                              d="M14 1.635C14 .733 13.267 0 12.365 0H4.913L0 4.684v9.681C0 15.267.733 16 1.635 16h10.73c.902 0 1.635-.733 1.635-1.635V1.635z"-->
                <!--                              fill="#ebebeb"/>-->
                <!--                        <path d="M4.913 0v3.069c-.043.899-.711 1.569-1.631 1.615H0L4.848.063 4.913 0z"-->
                <!--                              fill-opacity=".2"/>-->
                <!--                    </g>-->
                <!--                </svg>-->
                <!--            </i>-->

            </template>
            <template v-slot:cell(datetime)="data">
                <p v-if="data.item.datetime && !data.item.upload">
                    <date-time-text :date="data.item.datetime"></date-time-text>
                    <span v-if="!data.item.owner"  class="text--gray"> {{$t('history.by')}}  </span>
                    <span v-if="!data.item.owner">{{data.item.create_user_name}}</span>
                </p>
            </template>
            <template v-slot:cell(action1)="data">
                <file-gcode-info-button v-if="!data.item.status && data.item.active && data.item.file_type_id == 2" :file="data.item"/>
<!--            <b-button v-if="!data.item.status && data.item.active" size="-small" variant="-secondary btn&#45;&#45;outline">Repair</b-button>-->
            </template>
            <template v-slot:cell(action2)="data">
                <b-button v-if="!data.item.status && data.item.active && data.item.file_type_id == 1 "
                          @click="showEditor(data.item)" size="-small" variant="-ternary btn--outline btn--editors">{{$t('files.apps.layout')}}
                </b-button>
                <b-button v-if="!data.item.status && data.item.active && data.item.file_type_id == 2"
                          @click="showToolpathViewer(data.item)" size="-small" variant="-ternary btn--outline btn--editors">{{$t('files.apps.preview')}}
                </b-button>
            </template>
            <template v-slot:cell(action3)="data">
                <div v-if="!data.item.upload">
                    <file-slice-button v-if="!data.item.status && data.item.active && data.item.file_type_id != 2" :file-id="data.item.id" :file-name="data.item.filename"></file-slice-button>
                    <file-print-button v-else-if="data.item.active" :file="data.item"></file-print-button>
                </div>
                <div v-if="data.item.show_select_printers && data.item.upload" style="min-width: 380px">
                    <!--<b-form-select class="sel sel&#45;&#45;small" v-model="data.item.gtype" :options="gTupe"></b-form-select>-->
                    <!--<select  class="sel sel&#45;&#45;small"  v-model="data.item.ptype" >-->
                        <!--<option v-for="(printer, index) in getPrinterTypes" :key="index" :value="printer.id">{{printer.description}}</option>-->
                    <!--</select>-->
                    <label class="title-select-printer">{{$t('files.selectPrinterType')}}</label>

                    <printer-select :className="'sel--small inp inp--100 select-printers-50'" v-model="data.item.ptype"></printer-select>

                </div>
            </template>
            <template v-slot:cell(extra)="data">
                <file-action-buttons :file="data.item" @forceUpdateFiles="$emit('forceUpdateFiles')"> </file-action-buttons>
            </template>
            <template v-slot:cell(delete)="data">
                <span class="text--muted text--xsmall" v-if="!data.item.active">
                    <i class="icon icon--trash icon--trash--removed"  v-b-tooltip.hover :title="$t('files.msg.fileDeleteTooltips')">
                                        <svg >
                                        <use xlink:href="#trash"></use>
                                    </svg>
                                    </i>
                </span>
            </template>
        </b-table>
        <!--<b-modal v-model="sharingShow" size="lg" hide-footer>-->
        <!--<share-file :file-id="printer.printer_id"></share-file>-->
        <!--</b-modal>-->
        <infinite-loading v-if="items.length > 0" @infinite="handleInfiniteLoading">
            <div slot="no-more"></div>
            <div slot="no-results"></div>
        </infinite-loading>
    </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import File from '@/mixins/file'
  import Application from "@/mixins/application";
  //import moment from 'moment'
  import InfiniteLoading from 'vue-infinite-loading';
  import FileActionButtons from '@/components/files/FileActionButtons';
  import FilePrintButton from '@/components/files/FilePrintButton'
  import ModelPreview from "../ModelPreview";
  import FileTypeIcon from "./FileTypeIcon";
  import DateTimeText from "../DateTimeText";
  import FileSliceButton from "./FileSliceButton";
  import PrinterSelect from "@/components/printers/PrinterSelect";
  import PrintTime from "../PrintTime";
  import UserMixin from '@/mixins/user';
  import FileGcodeInfoButton from "@/components/files/FileGcodeInfoButton";
  export default {
    name: "FilesTable",
    components: {
      PrintTime,
      FileSliceButton,
      DateTimeText, FileTypeIcon, ModelPreview, FileActionButtons, InfiniteLoading, FilePrintButton, PrinterSelect,
      FileGcodeInfoButton
    },
    props: ['items', 'search'],
    mixins: [File, Application, UserMixin],
    mounted() {
      if (!this.isPrintersLoaded) {
        this.startListenPrinterEvents();
      }
    },
    methods: {
      ...mapActions(['deleteFile', 'undoFile', 'startListenPrinterEvents', 'addSelectFiles', 'removeSelectFiles']),
      showRenameFile(fileId) {
        this.$root.$emit('bv::show::modal', 'file-edit', '#focusThisOnClose', {data: fileId})
      },
      onChange(e){
        if(e.status){
          this.addSelectFiles(e.id)
        }else{
          this.removeSelectFiles(e.id)
        }

      },
      selectAllCheckbox(val) {
        this.selected = val ? this.items.map((item) => {
          return item.id
        }) : []
      },
      handleInfiniteLoading($state) {
        if (this.perPage < this.items.length) {
          this.perPage += 15;
          $state.loaded();
        } else {
          $state.complete();
        }
      },
      showSlicer(file) {
        this.oldApps_showCloudSlicer(file.id, null, 'slicer', file.filename);
      },
      showEditor(file) {
        this.oldApps_showStlEditor(file.id, file.filename);
      },
      showToolpathViewer(file) {
        this.oldApps_showToolpathViewer(file.id, file.filename);
      },
      openEditorPopUp(file) {
        if(file.active){
          if (file.file_type_id == '1') {
            this.showEditor(file)
          } else if (file.file_type_id == '2') {
            this.showToolpathViewer(file)
          }
        }
      },
      sortCompare(aRow, bRow) {
        // console.log(key)
        // console.log(aRow)
        // if(!aRow.active){
        //   return -1
        // }
        return new Date(aRow['datetime']).getTime() - new Date(bRow['datetime']).getTime()
      },
      showPrint(fileId, printer_type_id) {
        window.vuePrintFile(fileId, printer_type_id)
      },
      rowClass(item) {
        let classes = [];
        if (this.isFileHighlighted(item.id)) {
          classes.push('highlighted')
        }
        if (this.selected.indexOf(item.id) >= 0) {
          classes.push('selected')
        }

        return classes;
      }
    },
    computed: {
      ...mapGetters(['getFileTypeInfo', 'isPrintersLoaded', 'isFileHighlighted', 'gTupe', 'getPrinterTypes', 'getFilesSelect']),
      isAllSelect() {
        return this.items.length === this.selected.length
      },
      massAction: {
        get () {
          return this.getFilesSelect
        },
        set () {
          return false
        }
      }
    },
    watch: {


    },
    data() {
      return {

        perPage: 15,
        selected: [],
        sortBy: 'datetime',
        sortDesc: true,
        fields: [
          {
            key: 'check',
            label: '',
            class: 'check',
            sortable: false
          },
          // {
          //   key: 'id',
          //   label: '',
          //   class: 'id',
          //   sortable: false
          // },
          {
            key: 'img',
            label: '',
            class: 'img'
          },
          {
            key: 'name',
            sortable: true,
            class: 'name'
          },
          {
            key: 'log',
            label: 'Format',
          },
          {
            key: 'printing_duration',
            sortable: true,
            class: 'printing-duration'
          },
          {
            key: 'size',
            label: 'Size',
            sortable: true,
            formatter: value => {
              if (!value || value <= 0) {
                return '';
              }
              return this.bytesToSize(value).toLocaleLowerCase();
            },
            class: 'size'
          },
          {
            key: 'datetime',
            label: 'Changed',
            class: 'date',
            sortable: true

          },
          {
            key: 'action1',
            label: '',
            class: 'action1',
          },
          {
            key: 'action2',
            label: '',
            class: 'action2',
          },
          {
            key: 'action3',
            label: '',
            class: 'action3',
          },
          {
            key: 'extra',
            label: '',
            class: 'extra',
          },
          {
            key: 'delete',
            label: '',
            class: 'extra',
          },
        ],
        updatingFiles: {}
      }
    }
  }
</script>

<style lang="scss">
    .title-select-printer{
        width: 50%;
        float: left;
        text-align: right;
        padding-right: 15px;
        position: relative;
        top: 6px;
    }
    .select-printers-50{
        width: 50%;
        border-color: #3fad3c;
    }
</style>
